import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import CarGurusAdConfig from 'lib/CarGurusAdConfig';
import CGAdConfig from 'types/CarGurusAdConfig';
import { adComponentReadyToLoad, adComponentTearingdown } from 'redux-implementations/carGurusAds';
import { CarGurusElementId } from 'components/Ad/CGPixelAd';

export default function useCarGurusAd(carGurusAdConfig: CGAdConfig): { elementId: string } {
  const dispatch = useDispatch();

  useDeepCompareEffect(() => {
    const config = new CarGurusAdConfig({
      ...carGurusAdConfig,
    });

    dispatch(adComponentReadyToLoad(config.toJSON()));

    return (): void => {
      dispatch(adComponentTearingdown(config.toJSON()));
    };
  }, [carGurusAdConfig]);

  return { elementId: CarGurusElementId };
}
